import * as React from 'react';
import { Store } from 'redux';
import { match } from 'react-router-dom';
import * as types from '.';
import { RouteMatchProps } from '../containers/VenueProfileV2';

export class ComponentForSSR<P, S> extends React.Component<P, S> {
    static fetchData: (store: Store<types.StoreState>, match: match<any>, queryParams?: { [s: string]: string | [] }) => Promise<unknown>;
}
